import psychologicalDiagnosisItemValidator from 'forms/sections/psychological/diagnoses/validators/item';
import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { isPVQForm } from 'helpers/form';
import { PsychologicalExistingConditionsModel } from './types';

const psychologicalExistingConditionsValidator: ValidateJSModel<PsychologicalExistingConditionsModel> = {
  HasCondition: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }
    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },

  DidNotFollow: (value, attributes) => {
    if (attributes?.HasCondition?.value === 'Yes' && attributes?.ReceivedTreatment?.value === 'Yes') {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },

  DidNotFollowExplanation: (value, attributes) => {
    if (attributes?.HasCondition?.value === 'Yes' && attributes?.ReceivedTreatment?.value === 'Yes' && attributes?.DidNotFollow?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  ReceivedTreatment: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if (attributes?.HasPsychosis?.value === 'Yes' || attributes?.HasManic?.value === 'Yes' || attributes?.HasImpulsive?.value === 'Yes' || attributes?.HasPlanToHurt?.value === 'Yes') {
        return { presence: true, hasValue: { validator: hasYesOrNo } };
      }
      return {};
    }
    if (attributes?.HasCondition?.value === 'Yes') {
      return {
        presence: true,
        hasValue: { validator: { inclusion: ['Yes', 'No', 'Decline'] } },
      };
    }
    return {};
  },

  Explanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    if (attributes?.ReceivedTreatment?.value === 'No') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  TreatmentList: (value, attributes) => {
    if (attributes?.ReceivedTreatment?.value === 'Yes') {
      return {
        presence: true,
        accordion: {
          validator: psychologicalDiagnosisItemValidator,
          existingCondition: true,
          length: { minimum: 1, tooShort: 'error.treatment.items.minLength' }
        },
      };
    }
    return {};
  },

  Comments: {},
  ReceivedTreatmentComments: {},
  ReceivedTreatmentSummaryComments: {},
  DidNotFollowComments: {},
  DidNotFollowExplanationComments: {},
  DidNotReceiveTreatmentComments: {},
  HasPsychosis: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  HasManic: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  HasImpulsive: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  HasPlanToHurt: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  }
};

export default psychologicalExistingConditionsValidator;
